<template>
  <div class="tabs-dropdown-selector">
    <b-icon
      :type="arrowType"
      :class="{ hidden: activeTab < 1 }"
      icon="angle-left"
      size="is-large"
      @click="changeTab(activeTab - 1)"
    />
    <b-dropdown :disabled="disabled">
      <template #trigger>
      <b-button icon-right="angle-down" class="button">
        <span class="dropdown-entry" :style="{ 'max-width': currentContainerWidth - 270 + 'px' }">
          {{ tabs[activeTab] }}</span
        >
      </b-button>
      </template>
      <b-dropdown-item v-for="(tab, index) in tabs" :key="tab" @click="changeTab(index)">
        <span> {{ tab }}</span>
      </b-dropdown-item>
    </b-dropdown>
    <b-icon
      :type="arrowType"
      :class="{ hidden: activeTab >= tabs.length - 1 }"
      icon="angle-right"
      size="is-large"
      @click="changeTab(activeTab + 1)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { BButton, BIcon, BDropdown, BDropdownItem } from "buefy"

export default defineComponent({
  name: "TabsDropdownSelector",
  components: {
    BDropdownItem,
    BDropdown,
    BButton,
    BIcon,
  },
  props: {
    tabs: {
      type: Array,
    },
    activeTab: {
      type: Number,
    },
    currentContainerWidth: {
      type: Number,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["change-tab"],
  data() {
    return {
      arrowType: "is-primary",
    }
  },
  watch: {
    disabled(): void {
      if (this.disabled) {
        this.arrowType = "is-grey"
      } else {
        this.arrowType = "is-primary"
      }
    },
  },
  methods: {
    changeTab(tabIndex: number): void {
      if (!this.disabled) {
        this.$emit("change-tab", tabIndex)
      }
    },
  },
})
</script>

<!-- Style -->
<style lang="scss" scoped>
.tabs-dropdown-selector {
  display: flex;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;

  .dropdown {
    margin-left: auto;
    margin-right: auto;

    .button {
      color: $primary;
      border-color: $primary;
    }
  }
}

.icon {
  color: $primary;
  cursor: pointer;

  &.hidden {
    visibility: hidden;
  }
}

.dropdown-entry {
  max-width: 150px;
  text-overflow: ellipsis;
  display: block;
  overflow: hidden;
}
</style>
